/* eslint-disable @typescript-eslint/ban-ts-comment */
import MapboxViewer from "@/components/mapbox/MapboxViewer";
import { MapboxTileOverlayObject } from "../Objects/MapboxTileOverlayObject";
import { autobind } from "core-decorators";

class TileOverlayEntity {
  //@ts-ignore
  private _mapboxViewer: MapboxViewer;
  private _records: Map<string, MapboxTileOverlayObject> = new Map();

  constructor(mapboxViewer: MapboxViewer) {
    this._mapboxViewer = mapboxViewer;
  }

  @autobind
  add(tileOverlayObject: MapboxTileOverlayObject) {
    this._records.set(tileOverlayObject.contentId, tileOverlayObject);
  }

  @autobind
  remove(contentId: string) {
    const object = this._records.get(contentId);
    if (object) {
      object.dispose();
      this._records.delete(contentId);
    }
  }

  @autobind
  getById(contentId: string) {
    return this._records.get(contentId);
  }

  @autobind
  getAll() {
    return Array.from(this._records.values());
  }

  @autobind
  setVisible(contentId: string, visible: boolean) {
    const object = this._records.get(contentId);
    if (object) {
      object.setVisible(visible);
    }
  }

  // @autobind
  // setOpacity(contentId: string, opacity: number) {
  //   const object = this._records.get(contentId);
  //   if (object) {
  //     object.setOpacity(opacity);
  //   }
  // }

  @autobind
  dispose() {
    // Dispose all tile overlay objects
    this._records.forEach((object) => {
      object.dispose();
    });
    this._records.clear();
  }
}

export default TileOverlayEntity;
